import SPSW001PE16EU from './SPSW-001PE16EU.js';
import SPSW201PE16EU from './SPSW-201PE16EU.js';
import SPSW202PE16EU from './SPSW-202PE16EU.js';
import SPEM003CEBEU from './SPEM-003CEBEU.js';
import SPEM002CEBEU50 from './SPEM-002CEBEU50.js';
import SPSW104PE16EU from './SPSW-104PE16EU.js';
import SNSW001P16EU from './SNSW-001P16EU.js';
import SNSW002P16EU from './SNSW-002P16EU.js';
import SPSW002PE16EU from './SPSW-002PE16EU.js';
import SPSW102PE16EU from './SPSW-102PE16EU.js';
import SPSW002XE16EU from './SPSW-002XE16EU.js';
import SPSW101PE16EU from './SPSW-101PE16EU.js';
import SPSW202PE12UL from './SPSW-202PE12UL.js';
import SNSW102P16EU from './SNSW-102P16EU.js';
import SPSW101XE16EU from './SPSW-101XE16EU.js';
import SNSN0024X from './SNSN-0024X.js';
import SNSN0D24X from './SNSN-0D24X.js';
import SNPL00116US from './SNPL-00116US.js';
import SNPL00116IT from './SNPL-00116IT.js';
import SNPL00110IT from './SNPL-00110IT.js';
import SNPL00110EU from './SNPL-00110EU.js';
import SNPL00210EU from './SNPL-00210EU.js';
import SNPL00112EU from './SNPL-00112EU.js';
import SNPL00112UK from './SNPL-00112UK.js';
import SNDM0013US from './SNDM-0013US.js';
import SNPL10112EU from './SNPL-10112EU.js';
import SNSN0013A from './SNSN-0013A.js';
import SPSW102XE16EU from './SPSW-102XE16EU.js';
import SPSW202XE16EU from './SPSW-202XE16EU.js';
import SPSW202XE12UL from './SPSW-202XE12UL.js';
import SPSW003XE16EU from './SPSW-003XE16EU.js';
import SPSH002PE16EU from './SPSH-002PE16EU.js';
import SPEM003CEBEU400 from './SPEM-003CEBEU400.js';
import SPEM003REBEU2000 from './SPEM-003REBEU2000.js';
import SPEM003CEBEU63 from './SPEM-003CEBEU63.js';
import SNSW001P8EU from './SNSW-001P8EU.js';
import SNSW001X8EU from './SNSW-001X8EU.js';
import SNPM001PCEU16 from './SNPM-001PCEU16.js';
import SPSW004PE16EU from './SPSW-004PE16EU.js';
import SPSW201PE15UL from './SPSW-201PE15UL.js';
import SNSW001P15UL from './SNSW-001P15UL.js';
import SPSW001XE16EU from './SPSW-001XE16EU.js';
import SPSW201XE16EU from './SPSW-201XE16EU.js';
import SPSW201XE15UL from './SPSW-201XE15UL.js';
import SNSW001X15UL from './SNSW-001X15UL.js';
import SNSN0043X from './SNSN-0043X.js';
import SNDC0D4P10WW from './SNDC-0D4P10WW.js';
import SPDC0D5PE16EU from './SPDC-0D5PE16EU.js';
import SPDM001PE01EU from './SPDM-001PE01EU.js';
import SPDM002PE01EU from './SPDM-002PE01EU.js';
import SPSH102PE16EU from './SPSH-102PE16EU.js';
export const Gen2 = {
	'SPSW-001PE16EU': SPSW001PE16EU,
	'SPSW-201PE16EU': SPSW201PE16EU,
	'SPSW-202PE16EU': SPSW202PE16EU,
	'SPEM-003CEBEU': SPEM003CEBEU,
	'SPEM-002CEBEU50': SPEM002CEBEU50,
	'SPSW-104PE16EU': SPSW104PE16EU,
	'SNSW-001P16EU': SNSW001P16EU,
	'SNSW-002P16EU': SNSW002P16EU,
	'SPSW-002PE16EU': SPSW002PE16EU,
	'SPSW-102PE16EU': SPSW102PE16EU,
	'SPSW-002XE16EU': SPSW002XE16EU,
	'SPSW-101PE16EU': SPSW101PE16EU,
	'SPSW-202PE12UL': SPSW202PE12UL,
	'SNSW-102P16EU': SNSW102P16EU,
	'SPSW-101XE16EU': SPSW101XE16EU,
	'SNSN-0024X': SNSN0024X,
	'SNSN-0D24X': SNSN0D24X,
	'SNPL-00116US': SNPL00116US,
	'SNPL-00116IT': SNPL00116IT,
	'SNPL-00110IT': SNPL00110IT,
	'SNPL-00110EU': SNPL00110EU,
	'SNPL-00210EU': SNPL00210EU,
	'SNPL-00112EU': SNPL00112EU,
	'SNPL-00112UK': SNPL00112UK,
	'SNDM-0013US': SNDM0013US,
	'SNPL-10112EU': SNPL10112EU,
	'SNSN-0013A': SNSN0013A,
	'SPSW-102XE16EU': SPSW102XE16EU,
	'SPSW-202XE16EU': SPSW202XE16EU,
	'SPSW-202XE12UL': SPSW202XE12UL,
	'SPSW-003XE16EU': SPSW003XE16EU,
	'SPSH-002PE16EU': SPSH002PE16EU,
	'SPEM-003CEBEU400': SPEM003CEBEU400,
	'SPEM-003REBEU2000': SPEM003REBEU2000,
	'SPEM-003CEBEU63': SPEM003CEBEU63,
	'SNSW-001P8EU': SNSW001P8EU,
	'SNSW-001X8EU': SNSW001X8EU,
	'SNPM-001PCEU16': SNPM001PCEU16,
	'SPSW-004PE16EU': SPSW004PE16EU,
	'SPSW-201PE15UL': SPSW201PE15UL,
	'SNSW-001P15UL': SNSW001P15UL,
	'SPSW-001XE16EU': SPSW001XE16EU,
	'SPSW-201XE16EU': SPSW201XE16EU,
	'SPSW-201XE15UL': SPSW201XE15UL,
	'SNSW-001X15UL': SNSW001X15UL,
	'SNSN-0043X': SNSN0043X,
	'SNDC-0D4P10WW': SNDC0D4P10WW,
	'SPDC-0D5PE16EU': SPDC0D5PE16EU,
	'SPDM-001PE01EU': SPDM001PE01EU,
	'SPDM-002PE01EU': SPDM002PE01EU,
	'SPSH-102PE16EU': SPSH102PE16EU,
};
